module.exports = __webpack_public_path__ + "static/img/2797_phase_function_Paper_PointsHejduk_Prediction.d95f9d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2797_phase_function_Paper_PointsHejduk_Prediction.png
// module id = vp8n
// module chunks = 0